// extracted by mini-css-extract-plugin
export default {"btn":"MyButton_btn__bc9ez","btn__text":"MyButton_btn__text__gCdTd","btn__icon":"MyButton_btn__icon__+h5S5"};